module.exports = __webpack_public_path__ + "assets/img/score4.f9652f6a.png";